import React from "react";
import PropTypes from "prop-types";

import DialogTitle from "ui/DialogTitle";

import { getIcon, getColor, getLabel } from "utils/pageElements/helpers";

import { Box } from "@mui/material";

const Title = ({ pageElementId, pageElementType, onClose }) => {
  const action = pageElementId ? "Edit" : "Add";

  const icon = getIcon(pageElementType);
  const color = getColor(pageElementType);
  
  const Icon = !icon ? null : <Box
                  sx={{
                    width: 32,
                    height: 32,
                    borderRadius: 1,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    mr: 1.5,
                    bgcolor: color,
                    color: "white",
                  }}
                >
                  {icon}
                </Box>

  const title = `${action} ${getLabel(pageElementType)}`;

  return <DialogTitle Icon={Icon} title={title} onClose={onClose} />;
};

Title.propTypes = {
  pageElementId: PropTypes.number,
  pageElementType: PropTypes.string,
  onClose: PropTypes.func,
};

export default Title;
